export const SendReminderButton = ({ onClick, phone, message }) => (
  <a
    className="btn-lebrete d-flex justify-content-center align-items-center"
    href={`https://api.whatsapp.com/send/?phone=${phone}&text=${message}`}
    target="_blank"
    onClick={onClick}
    rel="noreferrer"
  >
    <div className="btn-lebrete-text">Enviar lembrete</div>
  </a>
);
